import { z } from 'zod';

// Iterable's device platform vocabulary for `registerDeviceToken`. Closed: the
// three values map one-to-one onto the native push providers the app captures
// (`apns`, `apns_sandbox`, `fcm`). Iterable still calls FCM `GCM`.
export const ITERABLE_PUSH_PLATFORMS = ['APNS', 'APNS_SANDBOX', 'GCM'] as const;
export const iterablePushPlatformSchema = z.enum(ITERABLE_PUSH_PLATFORMS);
export type IterablePushPlatform = z.infer<typeof iterablePushPlatformSchema>;

// Lifecycle of a row in the Iterable device-registration projection. A row is
// written before the Iterable call it describes, so its identity survives any
// failure between the call and the bookkeeping:
// - `registering`: a register call may have reached Iterable.
// - `registered`: Iterable acknowledged the register.
// - `disabling`: a disable call may have reached Iterable; the row is deleted
//   once Iterable acknowledges it.
export const ITERABLE_DEVICE_REGISTRATION_STATUSES = [
  'registering',
  'registered',
  'disabling',
] as const;
export const iterableDeviceRegistrationStatusSchema = z.enum(ITERABLE_DEVICE_REGISTRATION_STATUSES);
export type IterableDeviceRegistrationStatus = z.infer<
  typeof iterableDeviceRegistrationStatusSchema
>;
